import { onlineManager } from '@tanstack/react-query';
import { useCallback, useSyncExternalStore } from 'react';

export const useIsOnline = () => {
  return useSyncExternalStore(
    useCallback((onStoreChange) => onlineManager.subscribe(onStoreChange), []),
    () => onlineManager.isOnline(),
    () => onlineManager.isOnline()
  );
};
